import { InvariantViolation, registryKey, type ModelKind, type ModelImplByKind, type ModelRefOf, type ModelRegistry } from "@bsim/domain";
import type * as Cp2 from "./cp2_engine";

/** A ref the registry does not implement is a content-build defect, never a player outcome. */
export const resolveModel = (<K extends ModelKind>(registry: ModelRegistry, ref: ModelRefOf<K>): ModelImplByKind[K] => {
  const impl = (registry[ref.kind] as Readonly<Record<string, ModelImplByKind[K] | undefined>>)[registryKey(ref)];
  if (impl === undefined) throw new InvariantViolation("PENDING", `model ${ref.kind} ${registryKey(ref)} is not registered`);
  return impl;
}) satisfies typeof Cp2.resolveModel;
